import { DoDateServices } from "./Services.Interface";

const { REACT_APP_LOCAL } = process.env;
let url_base = `${REACT_APP_LOCAL}/EnterpriseServices/Sel`;
let method = "POST";

export interface GeneraQuejaRequest {
    userID : string,
    TipoConsulta: string,
    Numero_SS: string,
    Quejas : string,
    accountNumber:string
  }

  export interface GeneraQuejaResponse {
    respuesta : string,
    respuestadesc: string
  }

  export interface GeneraSugerenciaRequest {
    userID : string,
    TipoConsulta: string,
    NumeroSS: string,
    Sugerencias : string
  }

export const getDataService_EnviarQueja = (
    generaQuejaRequest : GeneraQuejaRequest
) => {

  const doDataServices: DoDateServices = {
    serviceName: "Solicitud/generarQueja",
    url: url_base,
    method: method,
    request: JSON.stringify(generaQuejaRequest)
  };

  return doDataServices;
};

export const getDataService_EnviarSugerencia = (
  generaSugerenciaRequest : GeneraSugerenciaRequest
) => {

  const doDataServices: DoDateServices = {
  serviceName: "Solicitud/crearSugerencia",
  url: url_base,
  method: method,
  request: JSON.stringify(generaSugerenciaRequest)
};

return doDataServices;
};